import type { BlacklistAutoRuleListQuery } from '@hprofits/api';

export type BlacklistAutoRulesListParams = Readonly<
  Pick<BlacklistAutoRuleListQuery, 'page' | 'pageSize' | 'sortBy' | 'sortDirection'> &
    Partial<Pick<BlacklistAutoRuleListQuery, 'name'>>
>;

// The grouped view builds its tree client-side, so paging would split a group's rules across
// pages. The list schema sets no maximum page size, so one oversized page stands in for "all".
export const LOAD_ALL_PARAMS: BlacklistAutoRulesListParams = {
  page: 1,
  pageSize: 9999,
  sortBy: 'id',
  sortDirection: 'desc',
};
